import { tourStep } from './tourRegistry';

export const bandaObjetivosSteps = [
  tourStep(
    'objetivos-header',
    'Objetivos',
    'Mide el compromiso por asistencia: puntos por ensayo y actuación, metas y ranking de la plantilla.',
  ),
  tourStep(
    'objetivos-crear',
    'Crear objetivo',
    'Define el periodo y si cuenta ensayos, actuaciones o ambos. Luego ajustas premios y puntuación.',
  ),
  tourStep(
    'objetivos-listado',
    'Listado',
    'Aquí ves todos los periodos. Haz clic en uno para abrir su ranking, filtros y configuración.',
    'top',
  ),
  tourStep(
    'objetivos-detalle',
    'Detalle y ranking',
    'Tras elegir un objetivo verás la tabla de puntos. Desde aquí editas premios y la puntuación por tipo de evento.',
    'top',
  ),
];
